export enum TemperatureSensorNameShortEnum {
    // WARM WATER enums
    WARM_WATER_TEMP_CIRCULATION = 'WW Zirkulation ',
    WARM_WATER_TEMP_BUFFER = 'WW Puffer ',
    WARM_WATER_TEMP_BOILER = 'WW Boiler ',
    WARM_WATER_TEMP_SOLAR = 'Solarspeicher ',
    FRESH_WATER_STATION_PRIMARY = 'FWST ',
    WARM_WATER_TEMP_OUTLET = 'WW Auslass ',
    CUSTOM_WATER = 'Ben.def. WW ',

    // TEMPERATURE enums, all temperature values are number and followed by the 2 endings, meaning they are all pair values
    HEATER_CL = 'HK ',
    HEATER_BL = 'KK ',
    HEATER_BL_SECONDARY = 'KK Sekundär ',
    HEATER_DH_PRIMARY = 'FWK Primär ',
    HEATER_DH_SECONDARY = 'FWK Sekundär ',
    HEATER_SL_PRIMARY = 'SLK Primär ',
    HEATER_SL_SECONDARY = 'SLK Sek. ',
    HEATER_BLC = 'PLK ',
    HEATER_BLC_SECONDARY = 'PLK Sekundär ',
    HEATER_WHLC = 'BLK ',
    HEATER_WHLC_SECONDARY = 'BLK Sekundär ',
    HEATER_BRINE_LOOP = 'Solekreis ',
    HEATER_HPL = 'WPK ',
    HEATER_LH = 'NK ',
    CUSTOM_LOOP = 'Ben.def. Kreis ',
    COLLECTION_LOOP = 'Haupts.kreis ',

    // endings for some numbered enuns
    FLOW_TEMP = ' VLT',
    RETURN_TEMP = ' RLT',
    FRESH_WATER_TEMP = ' WW',
}
